const basePPS = "Pps"


  const endpoints = {
   getMLSStoreFilter:`${basePPS}/Filter`,
   getMyPortfolioAdverts:`${basePPS}/MyPortfolio`,
   getPotentialAdverts:`${basePPS}/PotentialAdverts`,
   sendMLSRequest:`${basePPS}/SendPpsRequest`,
   acceptMLSRequest:`${basePPS}/AcceptPpsRequest`,
   recetMLSRequest:`${basePPS}/RejectPpsRequest`,
   getIncomingMLSRequst:`${basePPS}/GetIncomingPpsRequest`,
   getOutcomingMLSRequst:`${basePPS}/GetOutgoingPpsRequest`,
   removeMls:`${basePPS}/RemovePps`,

  }

  export default endpoints

